export default __webpack_public_path__ + "static/article-which-credit-card-is-best-for-you-v1-a8854438a7ea870963960a9e2903b2e2.jpg";